// API configuration
// Determine API base URL based on runtime config
// The API_BASE_URL can be configured via:
// 1. Window variable set by external config.js script
// 2. Default to http://localhost:3001 for development

export function getApiUrl(path: string): string {
    // Try window config first (if set by external script)
    if (typeof window !== 'undefined' && (window as any).API_CONFIG?.API_BASE_URL) {
        const apiBase = (window as any).API_CONFIG.API_BASE_URL;
        return `${apiBase}${path}`;
    }
    
    // Use relative URLs in production (same origin), localhost for local dev
    if (typeof window !== 'undefined' && window.location.hostname !== 'localhost') {
        // Production: use relative URL (same origin as the page)
        return path;
    }
    
    // Local development: use localhost:3001
    const apiBase = 'http://localhost:3001';
    return `${apiBase}${path}`;
}
